// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2MPL7","vLegacy":"SelectSecondary_vLegacy__2Er5y","error":"SelectSecondary_error__31XJF","disabled":"SelectSecondary_disabled__2rE4c"};